<template>
  <div class="setup-oauth">
    <Card flat>
      <template #title>
        <v-skeleton-loader
          v-if="pageLoading"
          type="heading"
          width="50%"
          height="28px"
          class="mt-1 mb-1"
        />
        <h5
          v-else
          class="mt-2 mb-2"
        >
          {{ oauthClientCapitalized }} login setup
        </h5>
      </template>

      <template #text>
        <v-skeleton-loader
          v-if="pageLoading"
          type="text"
          class="mt-4"
          height="38px"
        />
        <div
          v-else
          class="mt-4"
        >
          You are logged in via {{ oauthClientCapitalized }} identity provider.
          Would you like to make this login method mandatory for all users?
        </div>

        <v-skeleton-loader
          v-if="pageLoading"
          type="text"
          height="38px"
        />
        <DpplToggleButton
          v-else
          v-model="forced"
          :label="forced
            ? `${oauthClientCapitalized} authentication is mandatory`
            : `${oauthClientCapitalized} authentication is optional`"
        />

        <div v-if="forced">
          <div>
            The following emails will be redirected to {{ oauthClientCapitalized }} login page:
            <span
              v-for="(domain, index) in domains"
              :key="domain"
            >
              <template v-if="index > 0">,</template>
              user<strong>@{{ domain }}</strong>
            </span>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { useAppLoading } from '@/stores/app/loading';
import { useAppAuthData } from '@/stores/app/authData';
import { useSettingsSsoSetup } from '@/stores/settings/ssoSetup';
import { capitalize } from 'lodash-es';
import DpplToggleButton from '@/components/datapeople/DpplToggleButton.vue';
import Card from './Card.vue';

export default {
  name: 'SetupOauth',
  components: { Card, DpplToggleButton },

  computed: {
    ...mapState(useAppLoading, ['pageLoading']),
    ...mapState(useSettingsSsoSetup, ['domains', 'isGoogle', 'isMicrosoft']),

    ...mapState(useAppAuthData, ['authData']),

    forced: {
      get() {
        return this.isGoogle || this.isMicrosoft;
      },
      set(newValue) {
        if (newValue) {
          this.update({
            isActive: true,
            isForced: true,
            isGoogle: this.oauthClient === 'google',
            isMicrosoft: this.oauthClient === 'microsoft',
          });
        } else {
          this.update({ isActive: false });
        }
      },
    },

    oauthClient() {
      return this.authData.oauthClient;
    },

    oauthClientCapitalized() {
      return capitalize(this.oauthClient);
    },
  },

  methods: {
    ...mapActions(useSettingsSsoSetup, ['update']),
  },
};
</script>

<style scoped lang="less">
:deep(.v-input.v-switch) {
  display: flex;
  padding: 10px 0;
}

:deep(.v-input .v-label) {
  max-width: 375px;
  letter-spacing: normal;
}
</style>
